export default __webpack_public_path__ + "static/media/KK_E_Left_Top_sCrop.dfd742c0.svg";